export default __webpack_public_path__ + "static/media/Bridge-Funding.14517d2c.svg";